"use client";

import { useAuth0 } from "@auth0/auth0-react";
import { useClarityTestAuth0 } from "./test-auth0-provider";

export function useClarityAuth() {
  const isTestMode =
    typeof window !== "undefined" && window.__E2E_TEST_MODE__ === true;

  const testAuth = useClarityTestAuth0();
  const realAuth = useAuth0();

  return isTestMode ? testAuth : realAuth;
}
